import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X } from "lucide-react";
import { WHATSAPP_URL } from "@/constants/site";

export default function FloatingWhatsapp() {
  const [visible, setVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    onScroll();
    const t = setTimeout(() => setShowTooltip(true), 2500);
    return () => {
      window.removeEventListener("scroll", onScroll);
      clearTimeout(t);
    };
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 30, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 30, scale: 0.8 }}
          transition={{ type: "spring", stiffness: 260, damping: 20 }}
          className="fixed bottom-6 right-6 z-[60] flex items-end gap-3"
          data-testid="floating-whatsapp"
        >
          <AnimatePresence>
            {showTooltip && (
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 20 }}
                className="relative bg-zinc-900 border border-zinc-700 px-4 py-3 mb-2 max-w-[220px] shadow-xl"
              >
                <button
                  onClick={() => setShowTooltip(false)}
                  className="absolute -top-2 -right-2 w-5 h-5 bg-zinc-800 hover:bg-red-600 text-white rounded-full flex items-center justify-center"
                  aria-label="Fechar"
                  data-testid="floating-tooltip-close"
                >
                  <X size={10} />
                </button>
                <p className="text-xs text-white font-semibold leading-snug">
                  Olá! 👋 Fale com a Full Force pelo WhatsApp.
                </p>
                <div className="absolute top-1/2 -right-1.5 w-3 h-3 bg-zinc-900 border-r border-t border-zinc-700 rotate-45 -translate-y-1/2" />
              </motion.div>
            )}
          </AnimatePresence>

          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-whatsapp-btn"
            className="relative w-16 h-16 bg-[#25D366] hover:bg-[#1EBE57] text-white rounded-full flex items-center justify-center shadow-[0_0_25px_rgba(37,211,102,0.45)] hover:shadow-[0_0_40px_rgba(37,211,102,0.7)] hover:scale-110 transition-all duration-300"
            aria-label="WhatsApp"
          >
            <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
            <MessageCircle size={26} strokeWidth={2} />
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
